import { useMemo } from 'react';

import { Compensation } from 'types';
import { CompensationStatus, CompensationType, EmployeeStatus, LegalEntity } from 'enums';

const isValueMatchingWithSelected = <T>(value: T, selectedValues: T[]) =>
  !selectedValues.length || selectedValues.includes(value);

export const useFilteredCompensations = (
  compensations: Compensation[],
  selectedStatuses: CompensationStatus[] = [],
  employeeSearch: string | undefined = undefined,
  selectedEmployeeIds: number[] = [],
  selectedPeriods: number[] = [],
  selectedTypes: CompensationType[] = [],
  selectedLegalEntity: LegalEntity[] = [],
  selectedEmploymentStatuses: EmployeeStatus[] = [],
) => {
  return useMemo(() => {
    return compensations.filter(
      (compensation) =>
        (!employeeSearch || selectedEmployeeIds.includes(compensation.employeeID)) &&
        isValueMatchingWithSelected(compensation.periodId, selectedPeriods) &&
        isValueMatchingWithSelected(compensation.type, selectedTypes) &&
        isValueMatchingWithSelected(compensation.status, selectedStatuses) &&
        isValueMatchingWithSelected(compensation.employmentStatus, selectedEmploymentStatuses) &&
        isValueMatchingWithSelected(compensation.legalEntity, selectedLegalEntity),
    );
  }, [
    compensations,
    employeeSearch,
    selectedEmployeeIds,
    selectedPeriods,
    selectedTypes,
    selectedStatuses,
    selectedEmploymentStatuses,
    selectedLegalEntity,
  ]);
};
